// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"589":"0ee462c7","747":"384f3e5f"}[chunkId] + ".chunk.css";
};